import script from "./LastViewedProductsModalComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LastViewedProductsModalComponent.vue?vue&type=script&setup=true&lang=js"

import "./LastViewedProductsModalComponent.vue?vue&type=style&index=0&id=13532d9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13532d9a"]])

export default __exports__